import { render, staticRenderFns } from "./CustomerFormContainer.vue?vue&type=template&id=372faa43&scoped=true&"
import script from "./CustomerFormContainer.vue?vue&type=script&lang=ts&"
export * from "./CustomerFormContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372faa43",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
